import MosqueBooking from './MosqueBooking';

class MosqueBookingResponse {
  status: string;
  bookings: Array<MosqueBooking>;

}

export default MosqueBookingResponse;